import initialState from '../store/initialState'
import feedsTypes from '../constants/feedsTypes'

export default function feedsReducer(state = initialState.feeds, action) {
  //console.log(action.type)
  switch (action.type) {
    // case "SET_CURRENT_FEED":
    //   return {
    //     ...state,
    //     feed: action.payload
    //   };
    case feedsTypes.reset_errors:
      return {
        ...state,
        errors: []
      }

    // togle feed Actions
    case "SHOW_SIDEBAR_FEED_ACTIONS":
      return {
        ...state,
        showingProject: true
      }

    case "HIDE_SIDEBAR_FEED_ACTIONS":
      return {
        ...state,
        showingProject: false
      }

    case "SHOW_ARCHIVE_SIDEBAR_FEED_ACTIONS":
      return {
        ...state,
        showingProjectArchive: true
      }

    case "HIDE_ARCHIVE_SIDEBAR_FEED_ACTIONS":
      return {
        ...state,
        showingProjectArchive: false
      }

    // destroy feed
    case feedsTypes.destroy.request:
      return {
        ...state,
        destroying: true,
        destroyed: false
      };

    case feedsTypes.destroy.success:
      if (action.payload.feed) {
        return {
          ...state,
          destroying: false,
          destroyed: true,
          feed: action.payload.feed,
          pagination: action.payload.pagination
        };
      } else {
        return {
          ...state,
          destroying: false,
          destroyed: true,
          items: action.payload.feeds,
          pagination: action.payload.pagination
        };
      }

    case feedsTypes.destroy.failure:
      return {
        ...state,
        destroying: false,
        destroyed: false
      };

    // archive feed
    case feedsTypes.archive.request:
      return {
        ...state,
        setting_trash: true,
        set_trash: false
      };

    case feedsTypes.archive.success:
      if (action.payload.feed) {
        return {
          ...state,
          setting_trash: false,
          set_trash: true,
          feed: action.payload.feed,
          pagination: action.payload.pagination
        };
      } else {
        return {
          ...state,
          setting_trash: false,
          set_trash: true,
          items: action.payload.feeds,
          pagination: action.payload.pagination
        };
      }

    case feedsTypes.archive.failure:
      return {
        ...state,
        setting_trash: false,
        set_trash: false,
        errors: action.payload
      }

    // restore feed
    case feedsTypes.restore.request:
      return {
        ...state,
        setting_trash: true,
        set_trash: false
      };

    case feedsTypes.restore.success:
      if (action.payload.feed) {
        return {
          ...state,
          setting_trash: false,
          set_trash: true,
          feed: action.payload.feed,
          pagination: action.payload.pagination
        };
      } else {
        return {
          ...state,
          setting_trash: false,
          set_trash: true,
          items: action.payload.feeds,
          pagination: action.payload.pagination
        };
      }

    case feedsTypes.restore.success_minimal:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,

      };

    case feedsTypes.restore.failure:
      return {
        ...state,
        setting_trash: false,
        set_trash: false,
        errors: action.payload
      }


    // publish feed
    case feedsTypes.publish.request:
      return {
        ...state,
        setting_publish: true,
        set_publish: false
      };

    case feedsTypes.publish.success:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,
        feed: action.payload
      };

    case feedsTypes.publish.success_minimal:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,

      };

    case feedsTypes.publish.failure:
      return {
        ...state,
        setting_publish: false,
        set_publish: false,
        errors: action.payload
      }

    // update_xml
    case feedsTypes.update_xml.request:
      return {
        ...state,
        setting_publish: true,
        set_publish: false
      };

    case feedsTypes.update_xml.success:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,
        feed: action.payload
      };

    case feedsTypes.update_xml.success_minimal:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,
      };

    case feedsTypes.update_xml.failure:
      return {
        ...state,
        setting_publish: false,
        set_publish: false,
        errors: action.payload
      }


    // unpublish feed
    case feedsTypes.unpublish.request:
      return {
        ...state,
        setting_publish: true,
        set_publish: false
      };

    case feedsTypes.unpublish.success:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,
        feed: action.payload
      };

    case feedsTypes.unpublish.success_minimal:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,

      };

    case feedsTypes.unpublish.failure:
      return {
        ...state,
        setting_publish: false,
        set_publish: false,
        errors: action.payload
      }


    // GET project
    case feedsTypes.get.request:
      return {
        ...state,
        fetching: true,
        feed: {optimizations:[]},
        fetched: false
      };

    // GET project
    case feedsTypes.get.refresh_request:
      return {
        ...state,
        fetching: false,
        fetched: false
      };

    case feedsTypes.get.success:
      return {
        ...state,
        fetching: false,
        fetched: true,
        feed: {
          archives: state.feed.archives,
          ...action.payload
        }
      };

    case feedsTypes.get.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    case feedsTypes.get.reset_redirect:
      return {
        ...state,
        mustRedirect: false
      };

    // POST CREATE FEED
    case feedsTypes.create.request:
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      };

    case feedsTypes.create.success:
      return {
        ...state,
        fetching: false,
        fetched: true,
        mustRedirect: true,
        feed: action.payload
      };

    case feedsTypes.create.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    case feedsTypes.create.after_redirect:
      return {
        ...state,
        mustRedirect: true,
      }

    // POST CREATE OPTIMIZED FEED
    case feedsTypes.create_optimized.request:
      return {
        ...state,
        creating_optimized: true,
        // fetching: true,
        fetched: false
      };

    case feedsTypes.create_optimized.success:
      return {
        ...state,
        fetching: false,
        fetched: true,
        creating_optimized: false,
        feed: action.payload
      };

    case feedsTypes.create_optimized.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    // GET project archive
    case feedsTypes.project_archive.request:
      return {
        ...state,
        fetching: true,
        fetching_archive: true,
        fetched: false
      };

    case feedsTypes.project_archive.success:
      return {
        ...state,
        fetching: false,
        fetching_archive: false,
        fetched: true,
        feed: action.payload.feed
      };

    case feedsTypes.project_archive.failure:
      return {
        ...state,
        fetching: false,
        fetching_archive: false,
        fetched: false,
        errors: action.payload
      }


    // GET FEEDS INDEX
    case feedsTypes.index.request:
      return {
        ...state,
        fetching: true,
        fetched: false
      };

    case feedsTypes.index.success:
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.feeds,
        pagination: action.payload.pagination
      };

    case feedsTypes.index.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    // POST PUBLISH_ALL
    case feedsTypes.publish_all.request:
    return {
      ...state,
      setting_publish: true,
      set_publish: false,
      fetching: true,
      fetched: false
    };

    case feedsTypes.publish_all.success:
    return {
      ...state,
      setting_publish: false,
      set_publish: true,
      fetching: false,
      fetched: true,
      items: action.payload.feeds,
      pagination: action.payload.pagination
    };

    case feedsTypes.publish_all.failure:
    return {
      ...state,
      setting_publish: false,
      set_publish: false,
      fetching: false,
      fetched: false,
      errors: action.payload
    }

    // POST UN-PUBLISH_ALL
    case feedsTypes.unpublish_all.request:
    return {
      ...state,
      setting_publish: true,
      set_publish: false,
      fetching: true,
      fetched: false
    };

    case feedsTypes.unpublish_all.success:
    return {
      ...state,
      setting_publish: false,
      set_publish: true,
      fetching: false,
      fetched: true,
      items: action.payload.feeds,
      pagination: action.payload.pagination
    };

    case feedsTypes.unpublish_all.failure:
    return {
      ...state,
      setting_publish: false,
      set_publish: false,
      fetching: false,
      fetched: false,
      errors: action.payload
    }


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/feedsReducer.js